// This file is auto-generated during build. Do not edit.

export interface AFHConfig {
  VITE_CDN_URL: string;
  VITE_CDN_ID: string;
  VITE_JAMS_BACKEND_URL: string;
  VITE_JAMS_FRONTEND_URL: string;
  VITE_JUE_API_BASE_URL: string;
  VITE_DESCRIPTION_API_URL: string;
}

export const config: AFHConfig = {
  VITE_CDN_URL: "https://d30yj9jglnh5th.cloudfront.net",
  VITE_CDN_ID: "EVADZECPUWBGD",
  VITE_JAMS_BACKEND_URL: "https://a32xerzekl.execute-api.us-west-2.amazonaws.com/dev",
  VITE_JAMS_FRONTEND_URL: "https://jams.admin.dev.sodasoft.io",
  VITE_JUE_API_BASE_URL: "https://49o5mfj6gb.execute-api.us-west-2.amazonaws.com/prod",
  VITE_DESCRIPTION_API_URL: "https://2buwdokl05.execute-api.us-west-2.amazonaws.com/dev",
};
